import { app } from '../../../app';
import { Controller } from './manage-application.controller';

app.component('companyManageApplication', {
    bindings: {
        account: '<',
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./manage-application.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/manage-application.component.js